/**
 * UnderwayPhase - Phase 2 of voyage management
 */

import React from 'react';
import { Flag } from 'lucide-react';
import { Badge } from '../../../../catalyst/badge';
import VoyageQuickEntryPanel from '../VoyageQuickEntryPanel';
import VoyageLogSection from '../VoyageLogSection';

const UnderwayPhase = ({ 
  activeVoyage,
  logEntries,
  onAllFast,
  onAddLogEntry
}) => {
  const formatDuration = (ms) => {
    const hours = Math.floor(ms / 3600000);
    const minutes = Math.floor((ms % 3600000) / 60000);
    if (hours === 0) return `${minutes}m`;
    return `${hours}h ${minutes}m`;
  };

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-lg shadow">
        <div className="px-5 py-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-medium text-gray-900">Underway</h3>
              <p className="text-sm text-gray-500 mt-1">Vessel is at sea</p>
            </div>
            <Badge color="green">Active</Badge>
          </div>
        </div>
        
        <div className="p-5">
          {/* Quick status */}
          <div className="grid grid-cols-4 gap-4 mb-6">
            <div className="text-center">
              <p className="text-xs text-gray-500">Duration</p>
              <p className="text-sm font-medium">
                {activeVoyage && activeVoyage.actualDepartureTime ? 
                  formatDuration(Date.now() - new Date(activeVoyage.actualDepartureTime)) : 
                  '00:00'}
              </p>
            </div>
            <div className="text-center">
              <p className="text-xs text-gray-500">From</p>
              <p className="text-sm font-medium">{activeVoyage?.departurePort}</p>
            </div>
            <div className="text-center">
              <p className="text-xs text-gray-500">To</p>
              <p className="text-sm font-medium">{activeVoyage?.destinationPort}</p>
            </div>
            <div className="text-center">
              <p className="text-xs text-gray-500">Log Entries</p>
              <p className="text-sm font-medium">{logEntries.length}</p>
            </div>
          </div>

          {/* All Fast Button */}
          <div className="flex justify-center">
            <button
              onClick={onAllFast}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 flex items-center gap-2"
            >
              <Flag className="h-5 w-5" />
              All Fast - Arrive
            </button>
          </div>
        </div>
      </div>

      {/* Quick Entry Panel */}
      <VoyageQuickEntryPanel 
        activeVoyage={activeVoyage}
        onAddLogEntry={onAddLogEntry}
      />

      {/* Log entries */}
      <VoyageLogSection
        activeVoyage={activeVoyage}
        logEntries={logEntries}
      />
    </div>
  );
};

export default UnderwayPhase;